{
    "error" : "error",
    "report" : "Report / ",
    "transferCertificate"  :"TC - Birth certificate",
    "export" : "Export",
    "apply" : "Apply",
    "result" : "result available",
    "reset"  : "Reset",
    "wing" : "Wing : ",
    "section" : "Section : ",
    "class" : "Class : ",
    "category" : "Category : ",
    "caste" : "Caste : ",
    "gender" : "Gender : ",
    "all" : "All",
    "filterBy" : "Filter by :",
    "moreFilter" : "More filter",
    "lessFilter" : "Less filter",
    "noData" : "No data available",
    "show" : "Show result",
    "exportReport" : "Export report",
    "exportFirstMessage" :"You will export this report, and it will be sent to all super admins.",
    "exportSecondMessage" :"If you wish to send the report to a different email, please enter the email address.",
    "somethingWentWrong" : "Something went wrong.",
    "selectWing" : "Select wing",
    "selectSection" : "Select section",
    "selectClass" : "Select class",
    "selectGender" : "Select gender",
    "selectCaste" : "Select caste",
    "reportType" : "TRANSFER_BIRTH_CERTIFICATE",
    "reportFormat" : "Excel"
} 